import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { printLabel } from '../../../store/returns/grid/returns.grid.actions';
import Global from '../../../store/global-selectors';

const PrintLabels = () => {
  const dispatch = useDispatch();

  const printLabels = useCallback(() => {
    dispatch(printLabel());
  }, [dispatch]);

  const selectedReturnsCount = useSelector(Global.selectSelectedReturnsCount);
  return (
    <Button disabled={selectedReturnsCount < 1} onClick={printLabels} theme='tertiary'>
      <FormattedMessage defaultMessage='Print Label(s)' description='returnsPageHeader.printLabels' id='JdpLRu' />
    </Button>
  );
};

export default PrintLabels;
